import React from 'react';
import { withTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import KeyboardIcon from '@mui/icons-material/Keyboard';
import DashboardAppHeader from '../../DashboardAppHeader';
import { useStyles } from './styles';
import { IExternalKeyboardOverlay } from './interfaces';
import ReconnectExternalKeyboardButton from '@core/dashboard/components/Overlays/ExternalKeyboardOverlay/ReconnectExternalKeyboardButton';

const ExternalKeyboardOverlay = ({
  t: translate,
  onReconnectClick,
}: IExternalKeyboardOverlay) => {
  const classes = useStyles();
  const isButton = true;

  return (
    <Box sx={classes.root(isButton)}>
      <DashboardAppHeader isAuthorized hideLogo />
      <Box sx={classes.container}>
        <Box sx={classes.content}>
          <KeyboardIcon sx={classes.keyboardIcon} />
          <Typography sx={classes.title}>
            {translate('keyboardOverlayScreen.title')}
          </Typography>
          <Typography sx={classes.description}>
            {translate('keyboardOverlayScreen.text1')}
          </Typography>
          <Typography sx={classes.description}>
            {translate('keyboardOverlayScreen.text2')}
          </Typography>
        </Box>
        <ReconnectExternalKeyboardButton
          label={translate('keyboardOverlayScreen.reconnect')}
          onReconnectClick={onReconnectClick}
        />
      </Box>
    </Box>
  );
};

export default withTranslation()(ExternalKeyboardOverlay);
